/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 6; // Maximum number of products to display
      this.products = []; // Store product HTML in order
      this.recentlyViewedHandles = [];

      // Retrieve recently viewed items from local storage
      if (window.localStorage) {
        const recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds) {
          this.recentlyViewedHandles = JSON.parse(recentIds);
        }
      }
    }

    connectedCallback() {
      this.loadProducts();
    }

    async loadProducts() {
      // Fetch products in the order they appear in recentlyViewedHandles
      for (const handle of this.recentlyViewedHandles) {
        // Skip the current product if it's in the list
        if (handle === this.currentId) {
          continue;
        }

        const productHTML = await this.fetchProduct(handle);
        if (productHTML) {
          this.products.push(productHTML);
        }

        // Stop if we reach the max number of products
        if (this.products.length >= this.max) {
          break;
        }
      }

      // Display products in the exact order stored in `recently-viewed`
      this.renderProducts();
    }

    fetchProduct(handle) {
      const url = `${theme.routes.search_url}?view=recently-viewed&type=product&q=handle:${handle}`;

      return fetch(url)
        .then(response => response.text())
        .then(text => {
           console.log("recent_view>>>>>>>>>>>>>>>>",text);
          const html = document.createElement('div');
          html.innerHTML = text;
          
          // Assuming your product card HTML structure is in a specific class
          const product = html.querySelector('.product-card');
          
          if (!product) return '';  // If no product card is found, return an empty string

          // Add the correct container class for styling
          return `<li class="column">${product.outerHTML}</li>`;
        })
        .catch(e => {
          console.error(e);
          return '';
        });
    }

    renderProducts() {
      if (this.products.length) {
        this.container.innerHTML = this.products.join('');  // Render products as per order

        this.classList.add('product-recommendations--loaded');

        // Apply animations if ScrollTrigger is available
        if (window.ScrollTrigger && window.gsap) {
          ScrollTrigger.batch('.animations-true .product-card .product-featured-image-link', {
            start: "top 90%",
            onEnter: (elements, triggers) => {
              gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
            }
          });
        }
      } else {
        this.container.innerHTML = '<p>No recently viewed products.</p>';  // Display a message if no products are found
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
